import React from 'react'

const Notfound = () => {
  return (
    <div style={{marginTop:"80px"}}><h2>Sorry !! Zero product Found</h2></div>
  )
}

export default Notfound